// this file is auto-generated. do not edit manually.
// generated by scripts/generate-artifacts.ts

import { InstructionAction } from "./instruction-actions";
import deactivateInstructionAbiData from "@contracts/schemas/eip-712/actions/deactivate-instruction.json";
import refuelERC20AbiData from "@contracts/schemas/eip-712/actions/refuel-erc20.json";
import refuelAbiData from "@contracts/schemas/eip-712/actions/refuel.json";
import sweepDepositAccountERC20AbiData from "@contracts/schemas/eip-712/actions/sweep-deposit-account-erc20.json";
import sweepDepositAccountAbiData from "@contracts/schemas/eip-712/actions/sweep-deposit-account.json";
import sweepSkipCCTPDepositAccountAbiData from "@contracts/schemas/eip-712/actions/sweep-skip-cctp-deposit-account.json";
import transferERC20AbiData from "@contracts/schemas/eip-712/actions/transfer-erc20.json";
import transferAbiData from "@contracts/schemas/eip-712/actions/transfer.json";
import uniswapV3ExactInputAbiData from "@contracts/schemas/eip-712/actions/uniswap-v3-exact-input.json";

// export typed abi objects
export const deactivateInstructionAbi = deactivateInstructionAbiData;
export const refuelERC20Abi = refuelERC20AbiData;
export const refuelAbi = refuelAbiData;
export const sweepDepositAccountERC20Abi = sweepDepositAccountERC20AbiData;
export const sweepDepositAccountAbi = sweepDepositAccountAbiData;
export const sweepSkipCCTPDepositAccountAbi =
  sweepSkipCCTPDepositAccountAbiData;
export const transferERC20Abi = transferERC20AbiData;
export const transferAbi = transferAbiData;
export const uniswapV3ExactInputAbi = uniswapV3ExactInputAbiData;

// export types for type checking
export type DeactivateInstructionAbi = typeof deactivateInstructionAbi;
export type RefuelERC20Abi = typeof refuelERC20Abi;
export type RefuelAbi = typeof refuelAbi;
export type SweepDepositAccountERC20Abi = typeof sweepDepositAccountERC20Abi;
export type SweepDepositAccountAbi = typeof sweepDepositAccountAbi;
export type SweepSkipCCTPDepositAccountAbi =
  typeof sweepSkipCCTPDepositAccountAbi;
export type TransferERC20Abi = typeof transferERC20Abi;
export type TransferAbi = typeof transferAbi;
export type UniswapV3ExactInputAbi = typeof uniswapV3ExactInputAbi;

// map instruction action types to their corresponding abi definitions
export const instructionAbiMap = {
  [InstructionAction.DeactivateInstruction]: deactivateInstructionAbi,
  [InstructionAction.RefuelERC20]: refuelERC20Abi,
  [InstructionAction.Refuel]: refuelAbi,
  [InstructionAction.SweepDepositAccountERC20]: sweepDepositAccountERC20Abi,
  [InstructionAction.SweepDepositAccount]: sweepDepositAccountAbi,
  [InstructionAction.SweepSkipCCTPDepositAccount]:
    sweepSkipCCTPDepositAccountAbi,
  [InstructionAction.TransferERC20]: transferERC20Abi,
  [InstructionAction.Transfer]: transferAbi,
  [InstructionAction.UniswapV3ExactInput]: uniswapV3ExactInputAbi,
} as const;

export type InstructionAbiMapType = typeof instructionAbiMap;
